import { types } from "./Footer.actions";

export interface IFooterStateProps {
  hidden: boolean;
  clockAvailable: boolean;
  clockDate: Date;
}

const defaultState: IFooterStateProps = {
  hidden: false,
  clockAvailable: true,
  clockDate: null
};

export const footer = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_CLOCK_AVAILABLE:
      return {
        ...state,
        clockAvailable: action.value
      };
    case types.SET_CLOCK_DATE:
      return {
        ...state,
        clockDate: action.value
      };
    default:
      return state;
  }
};
